<template>
<div class="row" v-loading="loading">
  <div class="col-md-12">
    <card :title="title" v-if="modelSchema">
      <fg-input  :error="errorMessages.name" @input="populateUri" :max-length="modelSchema.name.maxLength" :required="modelSchema.name.required" v-model="model.name" :placeholder="'Name' | translate" :label="'Name' | translate"></fg-input>
      <fg-input  :error="errorMessages.uri" @input="inputUri"  :max-length="modelSchema.uri.maxLength" :required="modelSchema.uri.required" v-model="model.uri" :placeholder="'Slug' | translate" :label="'Slug' | translate"></fg-input>
      <div class="form-group has-label">
        <label for="" class="control-label" v-translate>Brand</label>
        <el-select class="select-success"
                   v-model="model.brand.id"
                   filterable
                   reserve-keyword
                   remote :remote-method="brandSearch"
                   :placeholder="'Select brand' | translate">
          <el-option
            v-for="item in brandChoices"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group has-label">
            <label for="" class="control-label" v-translate>Event dates</label>
            <el-date-picker type="datetimerange" v-model="eventDates" :default-time="['08:00:00', '18:00:00']"></el-date-picker>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group has-label">
            <label for="" class="control-label" v-translate>Working hours</label>
            <el-time-picker is-range v-model="workingHours" :default-time="['08:00:00', '18:00:00']"></el-time-picker>
          </div>
        </div>
      </div>

      <p-button type="info" round @click="save">
        <translate key="add" v-if="!isNew">Save</translate>
        <translate key="save" v-else>Add</translate>
      </p-button>
      <p-button type="info" round @click="saveAndClose">
        <translate key="add" v-if="!isNew">Save and close</translate>
        <translate key="save" v-else>Add and close</translate>
      </p-button>

    </card> <!-- end card -->
  </div> <!--  end col-md-6  -->
</div>
</template>

<script>
  import _ from 'lodash'
  import { Card } from 'src/components/UIComponents'
  import moment from 'moment'
  import {Select, Option, OptionGroup, DatePicker, TimePicker} from 'element-ui'

  export default {
    breadcrumb () {
      return {
        label: this.title,
        parent: {
          name: 'events-index'
        }
      }
    },
    components: {
      Card,
      [DatePicker.name]: DatePicker,
      [TimePicker.name]: TimePicker,
      [Select.name]: Select,
      [OptionGroup.name]: OptionGroup,
      [Option.name]: Option
    },
    props: {
      baseApi: {
        type: String,
        description: 'Remote API base URL',
        default: () => `expostat/event/`
      }
    },
    name: 'EventForm',
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    beforeRouteUpdate: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    computed: {
      title () {
        if (this.isNew) {
          return this.$gettext('Add event')
        } else {
          return this.$gettext('Edit event')
        }
      },
      isNew () {
        return this.model.id === null
      }
    },
    created () {
      this.getSchema()

    },
    mounted () {
      if (this.$route.params.id && !this.model.id) {
        this.loadRecord(this.$route.params.id)
      }
    },
    data () {
      return {
        loading: false,
        brandsLoading: false,
        brandChoices: [],
        errorMessages: {},
        autoUri: true,
        schema: null,
        modelSchema: null,
        eventDates: [moment().hour(8).minute(0).second(0), moment().add(1, 'week').hour(18).minute(0).second(0)],
        workingHours: [moment("08:00:00", "HH:mm:ss"), moment("18:00:00", "HH:mm:ss")],
        model: {
          id: null,
          brand: {
            id: null,
          },
          uri: "",
          name: null,
          start: null,
          end: null,
        }
      }
    },
    methods: {
      updateModel (model) {
        this.model = model
        this.eventDates = [new Date(this.model.start), new Date(this.model.end)]
        this.workingHours = [moment(this.model.worktimeStart, "HH:mm:ss"), moment(this.model.worktimeEnd, "HH:mm:ss")]
      },
      prepareModelToSave() {
        let model = _.cloneDeep(this.model)
        model.start = this.eventDates[0]
        model.end = this.eventDates[1]
        model.worktimeStart = moment(this.workingHours[0]).format("HH:mm:ss")
        model.worktimeEnd = moment(this.workingHours[1]).format("HH:mm:ss")
        return model
      },
      async loadRecord (id) {
        this.loading = true
        const result = await this.$http.get(`${this.$props.baseApi}${id}/`)
        this.updateModel(result.data)
        this.brandChoices = [this.model.brand]
        this.loading = false
        return result.data
      },
      async getSchema () {
        let url = this.$props.baseApi
        const result = await this.$http.options(url)
        this.schema = result.data
        this.modelSchema = this.schema.actions.POST

        const brands = await this.$http.get('expostat/brand/', {params: {limit: 10, ordering: '-latest_event_start'}})
        this.brandChoices = brands.data.results
      },
      async save () {
        this.loading = true
        const modelToSave = this.prepareModelToSave()
        const request = this.isNew ? this.$http.post(this.$props.baseApi, modelToSave) : this.$http.put(`${this.$props.baseApi}${this.model.id}/`, modelToSave)
        try {
          const result = await request
          this.updateModel(result.data)
          this.loading = false
          this.errorMessages = {}
          // // перенаправление при смене URL
          // if (this.$route.params.eventUri !== modelToSave.uri) {
          //   let route = {
          //     name: this.$route.name,
          //     params: _.cloneDeep(this.$route.params)
          //   }
          //   route.params.eventUri = modelToSave.uri
          //   this.$router.replace(route)
          // }
          return true
        } catch (error) {
          this.loading = false
          this.errorMessages = _.mapValues(error.response.data, x => x instanceof Array ? x.join(', ') : x)
          return false
        }
      },
      async saveAndClose () {
        await this.save()
        this.$router.go(-1)
      },
      async brandSearch(query) {
        let params = {limit: 10, ordering: '-latest_event_start'}
        if (query !== '') {
          params.search = query
        }
        const brands = await this.$http.get('expostat/brand/', {params})
        this.brandChoices = brands.data.results
      },
      populateUri (e) {
        if (this.autoUri) {
          this.model.uri = this.model.name.replace(/[^\w\dа-яА-Я]/gu, '-', -1).replace(/-+/g, '-').replace(/^-|-$/g, '')
        }
      },
      inputUri (e) {
        if (e === "") {
          this.autoUri = true
          this.populateUri(e)
        } else {
          this.model.uri = e.replace(/[^\w\dа-яА-Я]/gu, '-', -1).replace(/-+/g, '-')
          this.autoUri = false
        }
      }
    }
  }
</script>

<style scoped>

</style>
